<template>
<!-- eslint-disable max-len -->
<p
  v-if="starfighter"
  class="narrator-bubble sf"
  :style="style" :class="{ left, notail, center, bottom, thought }"
>
  <slot></slot>
  <tooltip
    :target="tooltipTarget"
  >
  </tooltip>
  <nameplate
    :character="speakingCharacter"
    :player="isPlayerSpeaking"
  />
</p>
<sliced-box
  v-else
  class="narrator-bubble native"
  :style="style"
  :class="{ left, center, bottom, thought }"
>
  <slot></slot>
  <tooltip
    :target="tooltipTarget"
  >
  </tooltip>
</sliced-box>
</template>

<script>
import { mapGetters } from 'vuex';

import Nameplate from '../ui/Nameplate';
import SlicedBox from '../ui/SlicedBox';
import Tooltip from './Tooltip';

export default {
  components: {
    Nameplate,
    SlicedBox,
    Tooltip,
  },
  props: {
    tooltipTarget: { type: String, default: 'speechBubble' },
    narrative: { type: Boolean },
    response: { type: Boolean },
    character: { type: Object },
    width: { type: String },
    height: { type: String },
    // switch tails to left
    left: { type: Boolean },
    // remove tails
    center: { type: Boolean },
    // place tails from bottom
    bottom: { type: Boolean },
    // thought bubbles, not triangles
    thought: { type: Boolean }
  },
  computed: {
    ...mapGetters([
      'game',
      'narrativeSpeaker',
      'narrativeResponder',
      'narrativeSpeakerIsPlayer',
      'narrativeResponderIsPlayer',
      'selectedAvatar',
      'starfighter',
      'native'
    ]),
    isPlayerSpeaking() {
      if (this.character) return (this.character === this.selectedAvatar);
      if (this.narrative) {
        if (this.response) {
          return this.narrativeResponderIsPlayer;
        }
        return this.narrativeSpeakerIsPlayer;
      }
      return false;
    },
    speakingCharacter() {
      if (this.character) return this.character;
      if (this.narrative) {
        if (this.response) {
          return this.narrativeResponder;
        }
        return this.narrativeSpeaker;
      }
      return null;
    },
    notail() {
      return !!(this.game.speechBubbleBackgroundColor);
    },
    style() {
      return {
        width: this.width || '930px',
        height: this.height || 'auto',
        color:
          this.game.speechBubbleTextColor
            ? this.game.speechBubbleTextColor
            : undefined,
        'background-color':
          this.game.speechBubbleBackgroundColor
            ? this.game.speechBubbleBackgroundColor
            : undefined,
        border:
          this.game.speechBubbleBackgroundColor
            ? 'none'
            : undefined,
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.narrator-bubble {
  position: absolute;
  color: black;
  font-size: 38px;
  // font-weight: bold;
  padding: 35px 50px;
  line-height: 1.5;
  margin: 0;
  display: flex;
  flex-flow: row;
  align-items: center;
  top: 180px;
}
.narrator-bubble.native {
  z-index: -1;
}
.narrator-bubble.sf {
  background-color: white;
  border: 4px solid black;
  border-radius: 24px;
  z-index: 10;
}
.narrator-bubble.sf::before {
  position: absolute;
  content: '';
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 50px 0 0 70px;
  border-color: transparent transparent transparent black;
  right: -70px;
  top: 50px;
}
.narrator-bubble.sf::after {
  position: absolute;
  content: '';
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 46px 0 0 64.4px;
  border-color: transparent transparent transparent white;
  right: -60px;
  top: 51px;
}
.narrator-bubble.left::before {
  border-width: 50px 70px 0 0;
  border-color: transparent black transparent transparent;
  left: -70px;
  right: unset;
}
.narrator-bubble.left::after {
  border-width: 46px 64.4px 0 0;
  border-color: transparent white transparent transparent;
  left: -60px;
  right: unset;
}
.narrator-bubble.sf.notail::before {
  border: none;
}
.narrator-bubble.sf.notail::after {
  border: none;
}
.narrator-bubble.left.notail::before {
  border: none;
}
.narrator-bubble.left.notail::after {
  border: none;
}
.narrator-bubble.bottom::before {
  top: unset;
  bottom: 150px;
}
.narrator-bubble.bottom::after {
  top: unset;
  bottom: 152px;
}
.narrator-bubble.thought::before {
  position: absolute;
  content: '';
  width: 50px;
  height: 50px;
  background-color: white;
  border: 4px solid black;
  border-radius: 50%;
  right: -65px;
  top: 70px;
}
.narrator-bubble.thought::after {
  position: absolute;
  content: '';
  width: 25px;
  height: 25px;
  background-color: white;
  border: 4px solid black;
  border-radius: 50%;
  right: -83px;
  top: 50px;
}
.narrator-bubble.left.thought::before {
  left: -65px;
  right: unset;
}
.narrator-bubble.left.thought::after {
  left: -83px;
  right: unset;
}
.narrator-bubble.bottom.thought::before {
  top: unset;
  bottom: 120px;
}
.narrator-bubble.bottom.thought::after {
  top: unset;
  bottom: 150px;
}
.narrator-bubble.center::before, .narrator-bubble.center::after {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/game/ui/NarratorBubble.vue